import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Spin, Button, Row, Col, Typography } from "antd";

//pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const { Text } = Typography;

const PdfViewer = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div style={{ maxWidth: "100%", overflow: "auto" }}>
      <Document
        file={fileUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<Spin size="large" tip="Loading document..." />}
        error={<Text type="danger">Failed to load PDF document</Text>}
        onLoadError={(error) =>
          console.error("Error loading PDF document:", error)
        }
      >
        <Page
          pageNumber={pageNumber}
          scale={scale}
          loading={<Spin tip="Loading page..." />}
        />

        <Row justify="center" gutter={16} style={{ marginTop: 16 }}>
          <Col>
            <Button
              onClick={() => setPageNumber(Math.max(1, pageNumber - 1))}
              disabled={pageNumber <= 1}
            >
              Previous
            </Button>
          </Col>
          <Col>
            <Text strong>
              Page {pageNumber} of {numPages || "--"}
            </Text>
          </Col>
          <Col>
            <Button
              onClick={() =>
                setPageNumber(Math.min(numPages || 1, pageNumber + 1))
              }
              disabled={pageNumber >= (numPages || 1)}
            >
              Next
            </Button>
          </Col>
          <Col>
            <Button onClick={() => setScale(scale * 1.2)}>Zoom In</Button>
          </Col>
          <Col>
            <Button onClick={() => setScale(scale * 0.8)}>Zoom Out</Button>
          </Col>
        </Row>
      </Document>
    </div>
  );
};

export default PdfViewer;
